var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIInfoAnbieterMerkmal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.235,
    height: 149.851,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clp1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M0 0h77.219v142.484H0z",
    shapeRendering: "crispEdges"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    clipPath: "url(#clp1)",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-383.195 -225.879)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M438.52 272.274c-11.029 1.221-19.596 2.046-25.461 2.452-5.966.402-14.333.608-24.863.608 0 0-4 .036-4 3.702v17.839c0 1.701.824 3.577 3.532 3.577 3.767 0 9.54.266 12.156.6.738.094 1.344.567 1.344 1.606l.102 32.215c0 4.172-7.186 8.223-11.528 8.459 0 0-3.783.542-3.783 3.689v16.753c0 3.288 3.913 3.59 3.913 3.59h65.75s3.734-.075 3.734-3.533v-17.376c0-3.165-4-3.393-4-3.393-5.209 0-12.455-4.125-12.455-8.187v-58.761c-.002-4.07-4.441-3.84-4.441-3.84zm-24.916 10.434c4.771-.331 11.355-.944 19.451-1.801.626-.066 1.904-.132 1.904 1.673v52.293c0 7.674 7.301 13.154 14.471 15.23.664.192 1.984.508 1.984 1.925v5.48c0 1.843-1.133 1.854-1.959 1.854h-53.7c-.724 0-1.738-.248-1.738-1.543v-5.65c0-1.654 1.159-1.844 1.743-2.046 6.713-2.328 13.569-7.923 13.569-15.251l-.022-33.748c-.828-7.805-7.36-8.377-14.594-8.52-.462-.009-.61-.016-1.076-.024 0 0-1.441.156-1.441-1.261v-6.463c0-1.587 1.555-1.556 1.81-1.556 7.995.001 14.625-.257 19.598-.592zm4.33-55.829c14.492 0 23.856 7.278 23.856 18.543 0 7.108-3.065 19.033-23.594 19.033-10.128 0-23.592-1.973-23.592-19.033 0-11.438 8.939-18.543 23.33-18.543zm.261 29.576c13.822 0 15.594-5.896 15.594-11.033 0-9.782-12.136-10.543-15.856-10.543-5.726 0-15.33 1.37-15.33 10.543.001 6.251 1.149 11.033 15.592 11.033z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIInfoAnbieterMerkmal);
export default __webpack_public_path__ + "static/media/Icon_i_Info_Anbieter_Merkmal.77b48a421cc0ae0f1540e9326fbc0003.svg";
export { ForwardRef as ReactComponent };